import './index.scss';
import { memo } from 'react';
import loaderImage from '../../../assets/chorki-almost.svg';
import pinwheel from '../../../assets/pinwheel-stick.webp';
import background from '../../../assets/sir-fazle-hasan-abed-web.png';

function Loader() {
  return (
    <div
      className="loader-container"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="centered-content">
        {/* <Checkbox
          // onCheck={onChange}
          styles={{ marginTop: 22 }}
          label={"Don't show this screen from next Login"}
        /> */}
        <span className="header">Welcome to MyBRAC</span>
        <span className="tagLine">
          The one-stop solution for everything related to BRAC
        </span>
        <img src={loaderImage} className="fan" alt="fan" />
        <img src={pinwheel} className="bottom-image" alt="stick" />
      </div>
    </div>
  );
}

export default memo(Loader);
